import { Close } from '@mui/icons-material';
import { Checkbox, FormControlLabel, Grid, IconButton, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { FormAddButton } from '../../../form/FormActions';
import { useI18n } from '../../../../../application/language/useI18n';

export interface IFormModalComponentProps {
  modalTitle?: string,
  onSave: () => void,
  onCancel: () => void,
  domain: any,
  children: any,
  dataCy?: string,
  buttonText?: string
  onChangeActive?: (e) => void,
  isCheckedActive?: boolean
  isNeedActiveButton?: boolean
}

export const FormModalComponent = observer((props: IFormModalComponentProps) => {
  const {
    domain,
    modalTitle = '',
    onSave,
    onCancel,
    children,
    buttonText = 'СОХРАНИТЬ',
    onChangeActive,
    isCheckedActive,
    isNeedActiveButton = false,
  } = props
  const classes = useStyles();
  useEffect(() => {
    domain.layoutDomain.setPageTitle(domain.ui.model.entity.id ? `Редактировать` : `Добавить`);
    return () => {
      domain.ui.validationErrors.setList([])
    };
  }, [domain]);

  return (
    <Grid container className={classes.formModal}>
      <Grid className={classes.formModalHeader}>
        <Grid className={classes.formModalTitle}>
          {modalTitle}
        </Grid>
        <Grid className={classes.formModalHeaderCloseButton}>
          <IconButton
            data-cy={`close-modal`}
            color="secondary"
            aria-label="Close"
            size="small"
            onClick={() => {
              onCancel()
            }}
          >
            <Close />
          </IconButton>
        </Grid>
      </Grid>
      <Grid className={classes.formModalBody}>
        {children}
      </Grid>
      <Grid className={classes.formModalButtonsBlock}>
        <Grid className={classes.formModalButtons}>
          {isNeedActiveButton && <IsActiveCheckbox onChange={onChangeActive} isChecked={isCheckedActive} />}
          <FormAddButton onSave={onSave} buttonText={buttonText} />
        </Grid>
      </Grid>
    </Grid>
  );
});

const IsActiveCheckbox = ({ onChange, isChecked }) => {
  const { translate } = useI18n();
  return (
    <Grid >
      <FormControlLabel
        style={{ width: '100%', padding: '0px 5px', margin: 0 }}
        control={
          <Checkbox
            sx={{
              '&.Mui-checked': {
                color: '#66BB6A',
              },
              '& .MuiSvgIcon-root': {
                fontSize: 24,
              },
            }}
            defaultChecked={true}
            onChange={onChange}
            checked={isChecked}
          />
        }
        label={translate('phrases.activeCategory')}
      />
    </Grid>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  formModal: {
    maxWidth: 700,
    minHeight: '500px',
    maxHeight: '80%',
    paddingTop: 24,
    paddingLeft: 24,
    paddingRight: 24,
  },
  formModalHeader: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',    // Центрирование заголовка
    alignItems: 'center',
    minHeight: '30px',
    width: '100%',
    marginBottom: '12px',
    fontWeight: '600',
    fontSize: '1.2rem',
  },
  formModalTitle: {
    textAlign: 'center',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    maxWidth: '80%',
  },
  formModalHeaderCloseButton: {
    position: 'absolute',
    right: 0,
  },
  formModalBody: {
    overflowY: 'scroll',
    height: '90%',
    maxHeight: '700px',
    width: '100%',
    paddingBottom: '32px'
  },
  formModalButtonsBlock: {
    width: 'calc(100% + 48px)',
    borderTop: '1px solid #FFFFFF1A',
    marginLeft: -24,
    marginRight: -24,
    padding: '12px 24px',
  },
  formModalButtons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));
